import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { dataGridModel, queryClient as qc } from 'keys';
import { CollapseButton, performAssessmentsHooks } from '.';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { getAssessmentsFetch, getAssessmentsTestTakers } from 'store/middlewares/assessment.crud';
import { initialPage, initialPageSize } from 'keys/pagination';
import { Table } from 'components';
import { PreformAssessmentStyles, AudioCheckButtonStyles } from './Style'
import { assessmentStatusOptions } from 'keys/statuses';
import { getCurrentSchoolYear, getCurrentSemester, getCurrentSemesterAndYear } from 'utils/general';
import { TablePageStyles } from 'styles/GlobalStyle';
import MicCheckAlert from 'pages/School/PerformAssessment/MicCheckAlert';

const Assessments = (props) => {
    const {
        filterSchema: fSchema, // אפשרות להגדיר סכמת פילטורים שונה,
        isBattery = true // האם מדובר בתצוגת סוללות או מבדקים מבודדים - תרגולים
    } = props

    const filterSchema = {
        primary: [
            { key: 'status', overrides: { multiple: true, placeholder: 'סטטוס מורחב', options: assessmentStatusOptions } },
        ],
        advanced: [
            { key: 'school_year' },
            { key: 'semester' },
            { key: 'categories' },
            { key: 'assessment_defs' }
        ]
    };

    const [assessmentFilters, setAssessmentFilters] = useState({
        status: assessmentStatusOptions.slice(0, -1),
        school_year: getCurrentSchoolYear(),
        semester: getCurrentSemester()
    })

    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)

    const [page, setPage] = useState(initialPage)
    const [rowOpen, setRowOpen] = useState(null)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")

    const [openMicCheck, setOpenMicCheck] = useState(false)

    const columns = performAssessmentsHooks.useColumns()
    const testTakerColumns = performAssessmentsHooks.useTestTakerColumns()

    const testTakersOptions = queryOptions({
        queryKey: [qc.assessmentsTestTakers, page, pageSize, sorting, assessmentFilters, headerFilters, testTaker, searchVal],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentsTestTakers({
                assessmentFilters: { ...assessmentFilters, isBattery: isBattery },
                headerFilters, testTaker, signal, page, pageSize, sorting, search: searchVal, model: qc.assessments
            })
            return data
        }
    })

    const assessmentsOptions = queryOptions({
        queryKey: [qc.ass, rowOpen],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentsFetch({
                test_taker: rowOpen,
                assessmentFilters: { ...assessmentFilters, isBattery: isBattery },
                headerFilters, testTaker,
                page: 1, pageSize: 100,
                signal, search: searchVal, model: qc.assessments
            })
            return data
        },
        enabled: !!rowOpen
    })
    const testTakers = useQuery(testTakersOptions)
    const assessments = useQuery(assessmentsOptions)

    const onCollapse = useCallback(() => {
        setRowOpen(null)
    }, [])

    useEffect(() => {
        setPage(initialPage)
    }, [headerFilters])

    return (
        <TablePageStyles>
            {openMicCheck && <MicCheckAlert handleAlert={setOpenMicCheck} />}
            <PreformAssessmentStyles>
                <Table
                    filterSchema={fSchema || filterSchema} // הטבלה תעביר את זה ל-FilterManager
                    filterValues={assessmentFilters}
                    onFilterChange={setAssessmentFilters}
                    customToolbar={
                        <AudioCheckButtonStyles onClick={() => setOpenMicCheck(true)}>
                            <i className="fa-light fa-headphones"></i>
                            {"בדיקת אודיו"}
                        </AudioCheckButtonStyles>
                    }
                    loading={testTakers.isFetching}
                    data={testTakers.data}
                    columns={testTakerColumns}
                    visibilityModelKey={dataGridModel.perform_assessments}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    searchVal={searchVal}
                    setSearchVal={setSearchVal}
                    sorting={sorting}
                    setSorting={setSorting}
                    queryKey={testTakersOptions.queryKey}
                    rowOpen={rowOpen}
                    setRowOpen={setRowOpen}
                    uniqueId="test_taker_id"
                    CustomCollapseComponent={CollapseButton}
                    collapse={{
                        show: true,
                        columns: columns,
                        showToolbar: true,
                        data: assessments.data?.results || { results: [] },
                        onCollapse: onCollapse,
                        showChollapseIcon: true,
                        visibilityModelKey: dataGridModel.perform_assessments
                    }}
                />
            </PreformAssessmentStyles>
        </TablePageStyles>
    )
}

export default Assessments

